/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React from 'react'

/**
 * StatusBadge — farbcodierte Slot-Tile für Host-Cockpit.
 *
 * @param {object} props
 * @param {'open'|'confirmed'|'checked-in'|'released'} props.status - Slot-Status
 * @param {string} [props.label] - Optionaler Override-Text
 * @param {string} [props.sublabel] - Zweite Zeile (z.B. Gastname)
 * @param {string} [props.className] - Zusätzliche Tailwind-Klassen
 */
export default function StatusBadge({
  status,
  label,
  sublabel,
  className = '',
}) {
  const config = STATUS_MAP[status] || STATUS_MAP.open

  return (
    <div
      className={`flex flex-col items-center justify-center w-[72px] h-[72px] rounded-xl text-center ${config.colors} ${className}`}
    >
      <span className="text-xs font-medium leading-tight">
        {label || config.label}
      </span>
      {sublabel && (
        <span className="text-[10px] leading-tight mt-0.5 w-full px-1 opacity-75 line-clamp-2">
          {sublabel}
        </span>
      )}
    </div>
  )
}

export const STATUS_MAP = {
  open: { label: 'Offen', colors: 'bg-green-100 text-green-800' },
  confirmed: {
    label: 'Vergeben',
    colors: 'bg-yellow-100 text-yellow-800',
  },
  'checked-in': {
    label: 'Eingecheckt',
    colors: 'bg-blue-100 text-blue-800',
  },
  released: {
    label: 'Freigegeben',
    colors: 'bg-gray-100 text-gray-800',
  },
}
